export const PRODUCT_NAME = 'Baruk Go';

export const PRODUCT_SHORT_NAME = 'Baruk Go';

export const DOCUMENT_TITLE = 'Baruk Go | Gestão Operacional';

export const PORTAL_DOCUMENT_TITLE = 'Baruk Go | Portal do Cliente';

export const LOGO_URL = '/logo.png';

export const APP_ICON_URL = '/icon.png';

export const BARUK_LOGO_URL = '/baruk-logo.png';

export const BARUK_MARK_URL = '/baruk-mark.png';

export const FAVICON_URL = '/favicon.ico';
